import get from 'lodash/get';

export const MAX_COMODINES = 3;
export const AVAILABLE_COMODINES_DATE = new Date("2026-07-01T15:00:00Z")

export const hasComodinesAvailable = (user = {}) =>
  Number(get(user, 'comodinesDisponibles', 0)) > 0 &&
  Number(get(user, 'comodinesUsados', 0)) < MAX_COMODINES;

/**
 * Indica si el usuario puede activar un comodín ahora.
 * Deshabilitado cuando: sin comodines, ya usó los 3, fase en curso,
 * próxima fase es grupos o final.
 */
export const canActivateComodin = (user, torneoEstado) => {
  if (!user || get(user, 'contributor') !== true) return false;
  if (!hasComodinesAvailable(user)) return false;

  if (!torneoEstado) return false;

  const faseActual = get(torneoEstado, 'faseActual');
  const estadoFase = get(torneoEstado, 'estadoFase');

  if (faseActual === 'groups' || faseActual === 'final' || faseActual === 'finalizado') {
    return false;
  }

  //Fuerza la habilitación de los comodines hasta AVAILABLE_COMODINES_DATE. Excepción válida solo para 16avos

  if (new Date() < AVAILABLE_COMODINES_DATE) return true;

  if (estadoFase === 'en_curso') return false;

  return get(torneoEstado, 'ventanaComodines', false) === true;
};
